export const SET_APPLICATION_TYPE = 'set_application_type';
export const RESET_APPLICATION_TYPE = 'reset_application_type';
export const SET_USER_SETTINGS = 'set_user_settings';
export const USER_SETTINGS_LOADING = 'user_settings_loading';
export const USER_SETTINGS_ERROR = 'user_settings_error';
